<template>
    <!-- modal-xl -->
    <b-modal id="createCheckModal" title="Create Check Modal" title-class="font-18" hide-footer no-close-on-backdrop>
        <div class="textcenter">
            <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
            <!-- <h5>Regulation: Regulation V.1</h5> -->
            <b-form>
                <b-form-group label="Title:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <b-form-input
                        v-model="$v.checkForm.prompt.$model"
                        size="sm"
                        :state="validateState('prompt')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                        Required
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-form>
        </div>

        <div class="modal-footer mt-3">
            <b-button @click="createCheck" variant="primary" type="button" class="btn btn-primary">
                Save
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";

export default {
    data: () => ({
        formSubmit: false,
        //values for the calendar
        checkForm: {
            prompt: "",
        },
    }),
    validations: {
        checkForm: {
            prompt: { required, minLength: minLength(3) },
        },
    },
    computed: {
        ...certificateValidationComputed,
    },
    methods: {
        ...certificateValidationMethods,
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.checkForm[name];
                return $dirty ? !$error : null;
            }
        },

        closeModal() {
            this.$bvModal.hide("createCheckModal");
        },
        createCheck() {
            this.formSubmit = true;

            this.$v.checkForm.$touch();
            if (this.$v.checkForm.$anyError) {
                return;
            }

            this.saveCreateValidationCheck({
                prompt: this.checkForm.prompt,
            }).then(() => {
                //eslint-disable-next-line
                console.log("created");

                // setTimeout(() => {
                //     this.setRegulationVersions();
                // }, 50);
                this.setValidationChecksByRegulationVersion({ regulation_version_id: this.selected_regulation_version_details.id });

                // this.setValidationChecksByRegulationVersion({regulation_version_id: });
                this.closeModal();

                Swal.fire(`Check Created`, "successfully", "");
            });

            //eslint-disable-next-line
            console.log("send the check");
        },
    },
    mounted() {
        //eslint-disable-next-line
        console.log("createCheckModal");
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
}
</style>
